export default {
    PRODUCT_LOADED: 'product-loaded',
};
